export default __webpack_public_path__ + "static/media/FreeVibrationEquationsImg.34127bad.jpg";